/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import PhoneFormatBehavior from '@/behaviors/PhoneFormatBehavior';
import TooltipView from '@/views/TooltipView';

import './RegistrationInfoForm.css';
import tmplRegistrationInfoForm from './RegistrationInfoForm.hbs';

const RegistrationInfoForm = View.extend({
  template: tmplRegistrationInfoForm,

  className: 'registration-info-form',

  ui: {
    phoneFormat: '.phone-format',
    tooltip: '.tooltip-container',
    pwTooltip: '#pwTooltip',
    userNameTooltip: '#userNameTooltip'
  },

  regions: {
    tooltip: '@ui.tooltip',
    pwTooltip: '@ui.pwTooltip',
    userNameTooltip: '@ui.userNameTooltip'
  },

  behaviors: {
    telephone: PhoneFormatBehavior
  },

  onRender() {
    this.showChildView(
      'pwTooltip',
      new TooltipView({
        model: new Backbone.Model({
          tooltipText:
            'Your password must be at least 12 characters long and contain at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character.',
          placement: 'right'
        })
      })
    );

    this.showChildView(
      'userNameTooltip',
      new TooltipView({
        model: new Backbone.Model({
          tooltipText:
            'Please do not user your email as your username.',
          placement: 'right'
        })
      })
    );
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  }
});

export default RegistrationInfoForm;
